import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { ImageDetailInitializer } from "./detailInitializer";

const ImageRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route path={`*`} element={<ImageDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default ImageRoute;
